
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class ComponentLoader extends Vue {
  @Prop({ type: String, required: false }) title: number;
  @Prop({ type: Boolean, required: false, default: false }) spinner: boolean;
  @Prop({ type: String, required: false, default: '#5FB4FF' }) spinnerColor: string;
}
